export default {
  home: {
    en: "Home",
    fr: "Presentation"
  },
  login: {
    en: "Login",
    fr: "Connexion"
  },
  signup: {
    en: "Sign Up",
    fr: "Inscription"
  }
};
